import React from "react";
import DnD from "../components/dnd/dnd";
// import AuthService from "../utils/OLD/auth";

// console.log(`This is on the home.js: ${loggedIn}`);

const Home = () => {
  // let loggedIn = AuthService.authChecker();
  return (
    <>
      <div className="d-flex justify-content-center homeCardCont">
        {/* {loggedIn ? <DnD /> : AuthService.redirectLogin()} */}
        <DnD />
      </div>
    </>
  );
};

export default Home;
